export default __webpack_public_path__ + "static/media/h-bar-multi.fed4dfcb.svg";